(function () {
  function initCarousel(group) {
    if (!group || group.dataset.magEdInitialized === 'true') return;

    var track = group.querySelector('[data-mag-ed-track]');
    var nav = group.querySelector('[data-mag-ed-nav]');
    var prevButton = group.querySelector('[data-mag-ed-prev]');
    var nextButton = group.querySelector('[data-mag-ed-next]');
    var cells = Array.prototype.slice.call(track ? track.querySelectorAll('.mag-ed__cell') : []);
    var dots = Array.prototype.slice.call(group.querySelectorAll('[data-mag-ed-dot]'));
    var dotLabelTemplate = nav ? nav.dataset.magEdLabelTemplate : '';
    var frame;

    if (!track || !nav || cells.length < 2) return;
    group.dataset.magEdInitialized = 'true';

    function maxScroll() {
      return Math.max(0, track.scrollWidth - track.clientWidth);
    }

    function cellPosition(cell) {
      return cell.getBoundingClientRect().left - track.getBoundingClientRect().left + track.scrollLeft;
    }

    function scrollStops() {
      var scrollLimit = maxScroll();

      return cells.reduce(function (stops, cell) {
        var position = Math.max(0, Math.min(cellPosition(cell), scrollLimit));
        var previous = stops[stops.length - 1];

        // At wider mobile/tablet widths several final cards can resolve to the
        // same maximum scroll position. Treat that as one navigation step.
        if (!previous || Math.abs(previous.position - position) > 2) {
          stops.push({ position: position });
        }

        return stops;
      }, []);
    }

    function currentIndex(stops) {
      if (!stops.length) return 0;

      var closestIndex = 0;
      var closestDistance = Infinity;
      stops.forEach(function (stop, index) {
        var distance = Math.abs(stop.position - track.scrollLeft);
        if (distance < closestDistance) {
          closestDistance = distance;
          closestIndex = index;
        }
      });
      return closestIndex;
    }

    function update() {
      var scrollLimit = maxScroll();
      var active = scrollLimit > 1;
      var stops = scrollStops();
      var index = currentIndex(stops);

      nav.hidden = !active;
      dots.forEach(function (dot, dotIndex) {
        var isAvailable = dotIndex < stops.length;
        var isActive = dotIndex === index;
        dot.hidden = !isAvailable;
        dot.classList.toggle('is-active', isActive);
        dot.setAttribute('aria-current', isActive ? 'true' : 'false');
        if (isAvailable && dotLabelTemplate) {
          dot.setAttribute(
            'aria-label',
            dotLabelTemplate.replace('__INDEX__', dotIndex + 1).replace('__TOTAL__', stops.length)
          );
        }
      });

      if (prevButton) prevButton.disabled = !active || index === 0;
      if (nextButton) nextButton.disabled = !active || index === stops.length - 1;
    }

    function goTo(index) {
      var stops = scrollStops();
      if (!stops.length) return;

      var boundedIndex = Math.max(0, Math.min(stops.length - 1, index));
      track.scrollTo({ left: stops[boundedIndex].position, behavior: 'smooth' });
    }

    if (prevButton) {
      prevButton.addEventListener('click', function () {
        goTo(currentIndex(scrollStops()) - 1);
      });
    }

    if (nextButton) {
      nextButton.addEventListener('click', function () {
        goTo(currentIndex(scrollStops()) + 1);
      });
    }

    dots.forEach(function (dot, index) {
      dot.addEventListener('click', function () {
        goTo(index);
      });
    });

    track.addEventListener('scroll', function () {
      if (frame) cancelAnimationFrame(frame);
      frame = requestAnimationFrame(update);
    });

    if ('ResizeObserver' in window) {
      new ResizeObserver(update).observe(track);
    } else {
      window.addEventListener('resize', update);
    }

    update();
  }

  var desktopQuery = window.matchMedia('(min-width: 990px)');
  var excerptFits = [];

  function initExcerptFit(inner) {
    var excerpt = inner.querySelector('.mag-ed-card--hero .mag-ed-card__excerpt');
    if (!excerpt || inner.dataset.magEdExcerptFit === 'true') return;
    inner.dataset.magEdExcerptFit = 'true';

    var hero = excerpt.closest('.mag-ed-card--hero');
    var observer = 'ResizeObserver' in window ? new ResizeObserver(schedule) : null;
    var frame;

    function fit() {
      frame = null;
      if (!inner.isConnected) return;

      var current = excerpt.style.getPropertyValue('--mag-ed-excerpt-lines');
      var cells = inner.querySelectorAll('.mag-ed__cell');
      var lineHeight = parseFloat(getComputedStyle(excerpt).lineHeight);

      if (!desktopQuery.matches || !cells.length || !lineHeight) {
        if (current) excerpt.style.removeProperty('--mag-ed-excerpt-lines');
        return;
      }

      // Measure with the excerpt collapsed: a hero taller than the side columns
      // can stretch the shared grid rows and push the left column cards down.
      excerpt.style.setProperty('--mag-ed-excerpt-lines', '1');
      var target = 0;
      cells.forEach(function (cell) {
        target = Math.max(target, cell.getBoundingClientRect().bottom);
      });
      var heroBase = hero.getBoundingClientRect().bottom - excerpt.getBoundingClientRect().height;
      var lines = String(Math.max(3, Math.floor((target - heroBase) / lineHeight)));

      excerpt.style.setProperty('--mag-ed-excerpt-lines', lines);
    }

    function schedule() {
      if (!frame) frame = requestAnimationFrame(fit);
    }

    // Observe only while fitting: below 990px the carousel callbacks resize the
    // grid synchronously, which an observer on this ancestor reports as a loop error.
    function watch() {
      if (!inner.isConnected) {
        if (observer) observer.disconnect();
        return false;
      }
      if (observer && desktopQuery.matches) observer.observe(inner);
      else if (observer) observer.disconnect();
      fit();
      return true;
    }

    if (!observer) window.addEventListener('resize', schedule);
    if (document.fonts) document.fonts.ready.then(schedule);
    window.addEventListener('load', schedule);
    excerptFits.push(watch);
    watch();
  }

  function onDesktopChange() {
    excerptFits = excerptFits.filter(function (watch) {
      return watch();
    });
  }

  if (desktopQuery.addEventListener) {
    desktopQuery.addEventListener('change', onDesktopChange);
  } else if (desktopQuery.addListener) {
    desktopQuery.addListener(onDesktopChange);
  }

  function init(scope) {
    if (!scope) return;
    if (scope.matches && scope.matches('[data-mag-ed-carousel]')) initCarousel(scope);
    scope.querySelectorAll('[data-mag-ed-carousel]').forEach(initCarousel);
    scope.querySelectorAll('.mag-ed__inner').forEach(initExcerptFit);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init(document);
    });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
